// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import opinionExpertEntity from './entities/opinion-expert.json';
import opinionExpertMenu from '../pages/opinion-expert/menu.json';
import opinionExpertFullForm from '../pages/opinion-expert/forms/full.json';
import opinionExpertContextForm from '../pages/opinion-expert/forms/context.json';
import opinionExpertMiniForm from '../pages/opinion-expert/forms/mini.json';
import opinionExpertLookupForm from '../pages/opinion-expert/forms/lookup.json';
import opinionExpertTableView from '../pages/opinion-expert/views/table.json';
import opinionExpertCardsView from '../pages/opinion-expert/views/cards.json';
import opinionExpertCalendarView from '../pages/opinion-expert/views/calendar.json';
import opinionExpertDashboardView from '../pages/opinion-expert/views/dashboard.json';

/** Тип запису «Експерт» зі сторінками пакета: меню, форми та подання з pages/opinion-expert/. */
export const opinionExpertDefinition: IRecordTypeDefinition = {
  ...opinionExpertEntity,
  views: assembleViewSet({
      table: opinionExpertTableView,
      cards: opinionExpertCardsView,
      calendar: opinionExpertCalendarView,
      dashboard: opinionExpertDashboardView,
  }),
  form: opinionExpertFullForm,
  forms: { full: opinionExpertFullForm, context: opinionExpertContextForm, mini: opinionExpertMiniForm, lookup: opinionExpertLookupForm },
  menu: opinionExpertMenu,
} as IRecordTypeDefinition;
